import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { ConfigProvider } from 'antd';
import { MsalProvider } from '@azure/msal-react';
import {
  AuthenticationResult,
  Configuration,
  EventMessage,
  EventType,
  PopupRequest,
  PublicClientApplication,
} from '@azure/msal-browser';

/// msal configuration ----------------------
const msalConfiguration: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_CLIENTID,
    authority: import.meta.env.VITE_AUTHORITY,
    redirectUri: import.meta.env.VITE_REDIRECT_URL,
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
};

export const loginRequest: PopupRequest = {
  scopes: [import.meta.env.VITE_AUTH_AUDIENCE_API],
};

export const msalInstance = new PublicClientApplication(msalConfiguration);
/// end configuration--------------------

msalInstance.addEventCallback(async (event: EventMessage) => {
  if (
    (event.eventType === EventType.LOGIN_SUCCESS ||
      event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
      event.eventType === EventType.SSO_SILENT_SUCCESS) &&
    event.payload
  ) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;

    sessionStorage.setItem('idToken', payload.idToken);
    sessionStorage.setItem('accessToken', payload.accessToken);
    sessionStorage.setItem('Scopes', payload.scopes.join(','));

    msalInstance.setActiveAccount(account);
  } else if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
    console.error('Token acquisition failed', event);
    // Implement proper error handling, potentially redirecting to login
  }
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <MsalProvider instance={msalInstance}>
    <ConfigProvider
      theme={{
        token: {
          borderRadius: 2,
          colorBorder: 'rgba(0,0,0,.3)',
          fontFamily: 'Roboto',
        },
        components: {
          Layout: {
            colorBgLayout: '#ffffff',
          },
        },
      }}
    >
      <App />
    </ConfigProvider>
  </MsalProvider>
);
